import React from 'react';

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="min-h-screen bg-midnight py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl md:text-6xl font-serif font-bold mb-12 text-center">Privacy Policy</h1>
        
        <div className="prose prose-invert max-w-none space-y-8 text-gray-400">
          <section>
            <h2 className="text-2xl font-serif font-bold text-white mb-4">1. Introduction</h2>
            <p>
              Welcome to AstroVidya.net, operated by Boomtech Solution Private Limited ("we," "us," or "our"). We are committed to protecting your personal information and your right to privacy. If you have any questions or concerns about our policy, or our practices with regards to your personal information, please contact us at hello@astrovidya.net.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-serif font-bold text-white mb-4">2. Information We Collect</h2>
            <p>
              We collect personal information that you voluntarily provide to us when registering at the Website, expressing an interest in obtaining information about us or our products and services, when participating in activities on the Website or otherwise contacting us.
            </p>
            <ul className="list-disc pl-6 space-y-2 mt-4">
              <li>Personal Details: Name, email address, phone number.</li>
              <li>Birth Details: Date, time, and place of birth (required for astrological readings).</li>
              <li>Payment Data: We collect data necessary to process your payment if you make purchases.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-serif font-bold text-white mb-4">3. How We Use Your Information</h2>
            <p>
              We use personal information collected via our Website for a variety of business purposes described below. We process your personal information for these purposes in reliance on our legitimate business interests, in order to enter into or perform a contract with you, with your consent, and/or for compliance with our legal obligations.
            </p>
            <ul className="list-disc pl-6 space-y-2 mt-4">
              <li>To generate personalized birth chart readings.</li>
              <li>To facilitate account creation and logon process.</li>
              <li>To send administrative information to you.</li>
              <li>To fulfill and manage your orders.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-serif font-bold text-white mb-4">4. Data Security</h2>
            <p>
              We have implemented appropriate technical and organizational security measures designed to protect the security of any personal information we process. However, please also remember that we cannot guarantee that the internet itself is 100% secure.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-serif font-bold text-white mb-4">5. Your Rights</h2>
            <p>
              In some regions (like the EEA and UK), you have certain rights under applicable data protection laws. These may include the right (i) to request access and obtain a copy of your personal information, (ii) to request rectification or erasure; (iii) to restrict the processing of your personal information; and (iv) if applicable, to data portability.
            </p>
          </section>

          <div className="pt-12 border-t border-white/10 text-center">
            <p className="text-xs text-gray-500 italic">Last Updated: March 31, 2026</p>
            <p className="text-xs text-gray-500 mt-2">© 2026 Boomtech Solution Private Limited. All rights reserved.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
